import { LayaGL } from "../../../layagl/LayaGL";
import { Pool } from "../../../utils/Pool";
import { RenderState2D } from "../../../webgl/utils/RenderState2D";
import { Command2D } from "./Command2D";
export class Set2DRTCMD extends Command2D {
    static create(renderTexture, clearColor, colorValue, renderInvertY = true, viewportX = 0, viewportY = 0) {
        let cmd = Set2DRTCMD._pool.take();
        cmd.renderTexture = renderTexture;
        cmd._setRenderTargetCMD.clearColor = clearColor;
        cmd._setRenderTargetCMD.clearColorValue = colorValue;
        cmd._setRenderTargetCMD.invertY = renderInvertY;
        cmd._setRenderTargetCMD.viewportX = viewportX;
        cmd._setRenderTargetCMD.viewportY = viewportY;
        return cmd;
    }
    get renderTexture() {
        return this._renderTexture;
    }
    set renderTexture(value) {
        this._renderTexture = value;
        if (value) {
            this._setRenderTargetCMD.size.setValue(value.width, value.height);
            this._setRenderTargetCMD.rt = value._renderTarget;
        }
        else {
            this._setRenderTargetCMD.size.setValue(RenderState2D.width, RenderState2D.height);
            this._setRenderTargetCMD.rt = null;
        }
    }
    constructor() {
        super();
        this._renderTexture = null;
        this._setRenderTargetCMD = LayaGL.render2DRenderPassFactory.createSetRendertarget2DCMD();
    }
    run() {
    }
    getRenderCMD() {
        return this._setRenderTargetCMD;
    }
    recover() {
        Set2DRTCMD._pool.recover(this);
        this._renderTexture = null;
    }
}
Set2DRTCMD._pool = Pool.createPool(Set2DRTCMD);
